import * as Phaser from "phaser-ce"
import { CCUtils } from "../../../common/CCUtils"
import { COLOR } from "../../../common/Color"
import { TransitionState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { ColorUtils } from "../../utils/ColorUtils"
import { PhaserUtils } from "../../utils/PhaserUtils"
import { Scale } from "../../utils/Scale"
import {
    TestimonialOutroInfo,
    Testimonials,
    VideoInfo,
} from "../../utils/TestimonialOutro"
import { Videos } from "../../utils/Videos"
import { CampCravingsAssets } from "./CampCravingsAssets"

export class CampCravingsExit extends Phaser.State {
    constructor(
        private videoKey?: string,
        private testimonialIntroAudio?: string,
    ) {
        super()
    }

    preload() {
        const load = PhaserUtils.makeLoader(
            this.game,
            "camp-cravings/transitions/testimonials",
        )

        this.testimonialIntroAudio =
            CCUtils.genderifyFileName(`testimonials.mp3`)
        load.audio(
            CampCravingsAssets.BUDDY_TESTIMONIALS_INTRO,
            this.testimonialIntroAudio,
        )

        load.image(CampCravingsAssets.TESTIMONIAL_1_IMAGE, "testimonial-1.png")
        load.image(CampCravingsAssets.TESTIMONIAL_2_IMAGE, "testimonial-2.png")

        load.video(CampCravingsAssets.TESTIMONIAL_1, "testimonial-1.mp4")
        load.video(CampCravingsAssets.TESTIMONIAL_2, "testimonial-2.mp4")

        const videoLocation = CCUtils.asset(
            CCUtils.genderifyFileName(`camp-cravings/transitions/outro.mp4`),
        )
        this.videoKey = CampCravingsAssets.OUTRO1
        this.game.load.video(this.videoKey, videoLocation)
    }

    async create() {
        await PhaserUtils.sharedCreateFunctions(this.game)
        Scale.resizeScreen(this.game, true)
        ColorUtils.setBackgroundColor(this.game, COLOR.black)

        const outroInfo = new TestimonialOutroInfo()

        outroInfo.testimonialIntroAudio =
            CampCravingsAssets.BUDDY_TESTIMONIALS_INTRO
        outroInfo.testimonials = [
            new VideoInfo(
                CampCravingsAssets.TESTIMONIAL_1_IMAGE,
                CampCravingsAssets.TESTIMONIAL_1,
            ),
            new VideoInfo(
                CampCravingsAssets.TESTIMONIAL_2_IMAGE,
                CampCravingsAssets.TESTIMONIAL_2,
            ),
        ]
        outroInfo.goTo = TransitionState.CAMP_CRAVINGS_EXIT2

        const videoGroup = this.game.add.group()
        await Videos.add(this.game, this.videoKey, {
            onComplete: () => {
                Buttons.create(
                    this.game,
                    "Next",
                    () => {
                        videoGroup.destroy()
                        Testimonials.showTestimonials(
                            this.game,
                            outroInfo,
                            "Click on the pictures to hear from some tobacco users about what it's like to crave nicotine.",
                        )
                    },
                    {
                        x: Scale.x(0.84),
                        y: Scale.y(0.9),
                        group: videoGroup,
                    },
                )
            },
            group: videoGroup,
            fillScreen: true,
        })
    }
}
